import React from 'react'

import styles from './ItemContentSection4.module.scss'

function ItemContentSection4({ item }) {
  // const [isReadStory, setIsReadStory] = React.useState(false)

  // const onReadStory = () => {
  //   setIsReadStory(!isReadStory)
  // }

  return (
    <div className={styles.contentSection4Wrapper}>
      <div className='content-item'>
        <div className='content-item-text'>
          <div className='text-box'>
            <div className='text-title'>
              <p>{item.title1}</p>
              <span>{item.title2}</span>
            </div>

            <div className='text-description'>{item.description}</div>
          </div>
        </div>

        <div className='content-img-box'>
          <div className='img'>
            <img src={item.image} alt='' className='content-img' />

            {/* <div
              className={`box-description ${
                isReadStory && 'box-description--expanse'
              }`}
              onClick={onReadStory}>
              {!isReadStory ? (
                <div className='box-description-container'>
                  <div className='text-read-story'>Read Story</div>
                  <div className='plus'>+</div>
                </div>
              ) : (
                <div className='description-text'>
                  <div className='description-text--title'>
                    {item.content.name}
                  </div>

                  <div className='description-text--text'>
                    {item.content.text}
                  </div>

                  <div className='icon-close' onClick={onReadStory}>
                    <span className='icon-ic-cancel close'></span>
                  </div>
                </div>
              )}
            </div>

            <div className='box-description-mobile'>
              <div className='description-text'>
                <div className='description-text--title'>
                  {item.content.name}
                </div>

                <div className='description-text--text'>
                  {item.content.text}
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemContentSection4
